<script setup lang="ts">
import {computed} from "vue";
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import NamaTimelineWrapper from "@/components/EditView/NamaTimelineWrapper.vue";
import {EditPresenter} from "@/utils/presenters/EditPresenter.ts";
import EditViewUtils from "@/utils/editView/EditViewUtils.ts";
import DTOTimelineData = namaTypes.DTOTimelineData;
//TODO:: [timeline,timeline,[timeline]]DTOTimelineData | DTOTimelineData[]
const props = defineProps<{ presenter: EditPresenter }>();
const {darkMode} = storeToRefs(useNamaFlagsStore());

const timelineData = computed<DTOTimelineData[]>(() => {
  return EditViewUtils.approvalCaseToTimelineData(props.presenter);
})
</script>

<template>
  <div class="tw-h-full tw-w-full">
    <q-card class="tw-h-full tw-w-full tw-flex tw-flex-col tw-shadow-none tw-bg-transparent tw-p-0">
      <div class="tw-grow">
        <q-scroll-area :dark="darkMode" class="tw-h-full tw-w-full dir-ltr">
          <NamaTimelineWrapper v-if="timelineData.length" :timeline="timelineData" isHorizontal supportSnakeVerticalLayout class="tw-flex-grow"/>
        </q-scroll-area>
      </div>
    </q-card>
  </div>
</template>
